import styled from 'styled-components';

export const Container = styled.div`
  > div:nth-of-type(3) {
    animation: rendering 1s;
  }
`;

export const GradientBackground = styled.div`
  position: absolute;
  top: 0px;
  width: 100%;
  height: 380px;
  z-index: -1;
  background: #e84e22;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 1024px) {
    justify-content: center;

    > h1 {
      display: none;
    }
  }
`;

export const UserPhoto = styled.img`
  width: 190px;
  height: 192px;
  border-radius: 50%;
  object-fit: cover;
`;

export const Title = styled.h1`
  font-family: 'Montserrat';
  font-weight: bold;
  font-size: 3rem;
  color: #fff;
  text-align: center;
  margin-left: 40px;

  > span {
    display: block;
    font-family: 'Montserrat';
    font-size: 3.4rem;
    color: #fff;
  }
`;

export const UpdateUserPhoto = styled.div`
  margin-top: 32px;

  > img {
    margin-left: 15px;

    width: 18px;
  }
`;

export const ContainerUpdateUserPhoto = styled.div`
  font-family: 'Montserrat';
  font-size: 1.5rem;
  color: #b3b1b1;
  cursor: pointer;
  width: 300px;
  display: flex;
  gap: 12px;
  align-items: center;

  @media (max-width: 1024px) {
    text-align: center;
    width: 100%;
  }

  > input[type='file'] {
    display: none;
  }
`

export const Name = styled.div`
  font-family: 'Montserrat';
  font-weight: bold;
  font-size: 2rem;
  color: var(--green24);
  margin-top: 20px;
`;

export const Options = styled.div`
  margin-top: 20px;
  > ul {
    display: flex;
    > li {
      font-family: 'Montserrat';
      font-weight: 600;
      font-size: 2rem;
      color: var(--green24);
      margin-right: 20px;
      list-style: none;
      border: none;
      transition: 1s all;
      cursor: pointer;
    }
  }
`;

export const Menu = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 1024px) {
    text-align: center;
    align-items: center;
    flex-direction: column;
  }
`;

export const Tooltip = styled.div`
  font-family: 'Montserrat';
  font-size: 1.2rem;
  margin-top: 20px;
  color: #e84e22;
`;
